import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, Card, EmptyState } from "../components/ui-ext";
import ExportButton from "../components/ExportButton";

export default function AccountingPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/accounting").then((r) => setItems(r.data)); }, []);
  const totalDr = items.filter((x) => x.cr_dr === "Dr").reduce((s, x) => s + (x.amount || 0), 0);
  const totalCr = items.filter((x) => x.cr_dr === "Cr").reduce((s, x) => s + (x.amount || 0), 0);
  return (
    <div>
      <PageHeader eyebrow="Ledger" title="Accounting" subtitle="Full financial ledger. Auto-updated when expenses are paid." right={<ExportButton endpoint="accounting.xlsx" testid="export-accounting-btn" />} />
      <div className="grid grid-cols-3 gap-4 mb-6">
        <Card className="p-5"><div className="mono text-[10px] uppercase text-slate-500">Total Debits</div><div className="mono text-2xl mt-2 text-red-400">₹ {totalDr.toLocaleString()}</div></Card>
        <Card className="p-5"><div className="mono text-[10px] uppercase text-slate-500">Total Credits</div><div className="mono text-2xl mt-2 text-green-400">₹ {totalCr.toLocaleString()}</div></Card>
        <Card className="p-5"><div className="mono text-[10px] uppercase text-slate-500">Net</div><div className="mono text-2xl mt-2">₹ {(totalCr - totalDr).toLocaleString()}</div></Card>
      </div>
      <Card>
        {items.length === 0 ? <EmptyState title="Ledger empty" hint="Payments recorded via Expense Approvals will appear here." /> : (
          <div className="overflow-x-auto">
            <table className="w-full tech-table">
              <thead><tr><th>Date</th><th>Emp</th><th>Project</th><th>Purpose</th><th>Journal</th><th>Amount</th><th>From</th><th>Cr/Dr</th><th>Ref</th></tr></thead>
              <tbody>
                {items.map((a) => (
                  <tr key={a.id}>
                    <td className="mono text-xs">{a.date?.slice(0, 10)}</td>
                    <td>{a.emp_name || "—"}</td>
                    <td>{a.project || "—"}</td>
                    <td>{a.purpose}</td>
                    <td className="text-xs text-slate-400 max-w-xs truncate">{a.journal}</td>
                    <td className={`mono font-medium ${a.cr_dr === "Dr" ? "text-red-400" : "text-green-400"}`}>₹ {a.amount?.toLocaleString()}</td>
                    <td className="text-xs">{a.from_account || "—"}</td>
                    <td className="mono">{a.cr_dr}</td>
                    <td className="mono text-xs">{a.ref_no || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
